import * as React from 'react';

import { createClient, type Client } from '@connectrpc/connect';
import { CameraLocalService } from '@rematter/frontend-lib-api-client/grpc/sidecar/v1/camera_local_api_pb';

import { useLibp2p } from './useLibp2p';

export type CameraLocalClient = Client<typeof CameraLocalService>;

export function useCameraLocalClient(
  sidecarId: string,
): CameraLocalClient | null {
  const { getTransport, connections } = useLibp2p();

  const isConnected = connections.get(sidecarId)?.connected ?? false;

  return React.useMemo(() => {
    if (!isConnected) return null;

    const transport = getTransport(sidecarId);
    if (!transport) return null;

    return createClient(CameraLocalService, transport);
  }, [sidecarId, getTransport, isConnected]);
}
